<template>
  <div
    v-if="value !== null && value !== ''"
    class="field"
    :style="{ '--form-item-width': grid.Cols, '--form-item-height': grid.Rows, '--form-item-start': grid.Offset }"
  >
    <div class="iframe-container">
      <iframe
        ref="iframe"
        :srcdoc="value"
        @load="adjustHeight"
        scrolling="no"
        frameborder="0"
        style="width: 100%; border: none; overflow: hidden"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    value: {
      type: String,
      required: false,
      default: () => ''
    },
    grid: Object
  },
  methods: {
    adjustHeight() {
      const frame = this.$refs.iframe
      if (frame && frame.contentWindow) {
        frame.style.height = '0px'
        frame.style.height = frame.contentWindow.document.body.scrollHeight + 50 + 'px'
      }
    }
  }
})
</script>
